/** Public aliases are assigned automatically, regardless of hosted form configuration. */
const UserFieldDisplayName = () => null;

export default UserFieldDisplayName;
